import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { CurrencyPipe, NavigationService } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MessageType } from '../../../../model/message.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { DepositService } from '../../../../service/deposit.service';
import { ResizeService } from '../../../../service/resize.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-pl-verification-message',
    templateUrl: 'pl-verification-message.component.html',
    imports: [MessageComponent, TranslateModule, CurrencyPipe],
})
export class PLVerificationMessageComponent implements OnInit, OnDestroy {
    private behaviorData = inject(BehaviorDataService);
    private depositService = inject(DepositService);
    private userDataService = inject(UserDataService);
    private resizeService = inject(ResizeService);

    private navigationService = inject(NavigationService);
    kycPLverification: boolean;
    kycRedirectionUrl: string;
    bwinPLkycverification: any;
    kycPLlimitverification: any;
    depositLimit: any;
    userBalance: any;
    subscriptions$: Subscription[] = [];
    currencyPLN: string = 'PLN';
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit(): void {
        if (
            ['SUSPENDED_GRACE_DAYS_OVER', 'SUSPENDED_DEPOSIT_AMOUNT_EXCEEDED'].includes(
                this.userDataService?.userData?.userInfo?.ezecashCategoryComment,
            )
        ) {
            this.behaviorData.changekycPLverification(true);
            this.kycRedirectionUrl = this.userDataService?.userData?.configParams?.kyc_verify_redirection_url;
        } else {
            this.behaviorData.changekycPLverification(false);
        }

        this.userBalance = this.userDataService?.userData?.configParams?.userBalance;
        this.depositLimit = this.userDataService?.userData?.configParams?.deposit_limit_constraint;

        this.getBehaviorData();
    }

    getBehaviorData() {
        this.subscriptions$.push(
            this.behaviorData.getKycPLverification.subscribe((data) => {
                this.kycPLverification = data;
                this.resizeService.resizeCashier();
            }),
        );
        this.subscriptions$.push(
            this.behaviorData.getbwinPLkycverification.subscribe((data) => {
                this.bwinPLkycverification = data;
                this.resizeService.resizeCashier();
            }),
        );
        this.subscriptions$.push(
            this.behaviorData.getkycPLlimitverification.subscribe((data) => {
                this.kycPLlimitverification = data;
                this.resizeService.resizeCashier();
            }),
        );
    }

    openKycRedirectUrl() {
        this.navigationService.goTo(this.kycRedirectionUrl, { forceReloadTarget: 'top' });
    }

    submitPLDeposit() {
        this.depositService.showDepositFailure.set(false);
        this.resizeService.resizeCashier();
        this.depositService.submitDeposit();
    }

    depositBack() {
        this.behaviorData.changeHideInputPage(false);
        this.behaviorData.changebwinPLkycverification(null);
    }

    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
